import { Badge, Box, Button, Heading, Image, Text } from '@wix/design-system'
import React, { FC, MouseEventHandler } from 'react'

import { cardBoxDataHooks as dataHooks } from './CardBox.dataHooks'
import s from './CardBox.scss'

interface CardBoxProps {
  imageUrl: string
  title: string
  description: string
  buttonText: string
  badge?: string
  onClick?: MouseEventHandler<HTMLButtonElement>
  dataHook?: string
}

export const CardBox: FC<CardBoxProps> = ({ imageUrl, description, title, buttonText, badge, onClick, dataHook }) => (
  <Box
    boxShadow="var(--wsr-shadow20, 0 2px 4px 0 rgba(22, 45, 61, 0.12), 0 0 6px 0 rgba(22, 45, 61, 0.12))"
    borderRadius="8px"
    padding="SP4"
    direction="vertical"
    align="center"
    width="370px"
    gap="21px"
    className={s.box}
    dataHook={dataHook}
  >
    <Box>
      <Image transparent width="120px" height="120px" src={imageUrl} dataHook={dataHooks.image()} />
    </Box>
    <Box gap="SP1" direction="vertical" flex={1}>
      <Heading as="span" className={s.title} dataHook={dataHooks.title()}>
        {title}
      </Heading>
      <Text weight="thin" dataHook={dataHooks.description()}>
        {description}
      </Text>
    </Box>
    <Box width="209px">
      <Button fullWidth size="large" onClick={onClick} dataHook={dataHooks.button()}>
        {buttonText}
      </Button>
    </Box>
    {badge && (
      <Badge className={s.badge} dataHook={dataHooks.badge()}>
        {badge}
      </Badge>
    )}
  </Box>
)
